// src/pages/sales-order/tabs/UdfTab.jsx
import React from "react";
import SectionGrid from "../component/SectionGrid";

export default function UdfTab({
    fields,
    formData,
    errors,
    onChange,
    readOnly,
    getInputTypeForField,
    getValueForField,
}) {
    return (
        <SectionGrid
            fields={fields}
            formData={formData}
            errors={errors}
            onChange={onChange}
            readOnly={readOnly}
            idPrefix="udf"
            getInputTypeForField={getInputTypeForField}
            getValueForField={getValueForField}
        />
    );
}
